import { Stack, Typography } from "@mui/material";
import moment from "moment-timezone";
import { SchedulerStoreType } from "../../state/scheduler.store";
import { useI18nLanguage } from "../../hooks/i18nLanguage";

interface IMeetingWhenProps {
  prevSelectedTimeSlot: string | null;
  selectedTimeSlot: string | null;
  timezone: string;
  meetingDuration: number;
  strikePrevSlot: boolean;
  sessionData: SchedulerStoreType["sessionData"];
  previouslySelectedDuration?: number;
}

export const MeetingWhen: React.FC<IMeetingWhenProps> = ({
  prevSelectedTimeSlot,
  selectedTimeSlot,
  timezone,
  meetingDuration,
  sessionData,
  strikePrevSlot,
  previouslySelectedDuration
}) => {
  const { selectedLanguageForMoment } = useI18nLanguage();
  return (
    <>
      {prevSelectedTimeSlot && prevSelectedTimeSlot.length > 0 && (
        <Typography
          fontSize="15px"
          fontWeight={500}
          sx={
            strikePrevSlot
              ? {
                  textDecorationStyle: "solid",
                  textDecorationLine: "line-through"
                }
              : {}
          }
        >
          <Stack>
            {" "}
            {moment(prevSelectedTimeSlot)
              .tz(timezone)
              .locale(selectedLanguageForMoment)
              .format("dddd, LL")}
          </Stack>
          <Stack direction="row">
            {moment(prevSelectedTimeSlot)
              .tz(timezone)
              .locale(selectedLanguageForMoment)
              .format("LT")}{" "}
            {" - "}
            {moment(prevSelectedTimeSlot)
              .tz(timezone)
              .add(previouslySelectedDuration ?? meetingDuration, "minutes")
              .locale(selectedLanguageForMoment)
              .format("LT")}{" "}
            ({timezone})
          </Stack>
        </Typography>
      )}

      {selectedTimeSlot && (
        <Typography
          fontSize="15px"
          fontWeight={500}
          mt={prevSelectedTimeSlot ? 1 : 0}
        >
          <Stack>
            {" "}
            {moment(selectedTimeSlot)
              .tz(sessionData?.selectedTimezone ?? timezone)
              .locale(selectedLanguageForMoment)
              .format("dddd, LL")}
          </Stack>
          <Stack direction="row">
            {moment(selectedTimeSlot)
              .tz(sessionData?.selectedTimezone ?? timezone)
              .locale(selectedLanguageForMoment)
              .format("LT")}{" "}
            {" - "}
            {moment(selectedTimeSlot)
              .tz(sessionData?.selectedTimezone ?? timezone)
              .add(meetingDuration, "minutes")
              .locale(selectedLanguageForMoment)
              .format("LT")}{" "}
            ({sessionData?.selectedTimezone ?? ""})
          </Stack>
        </Typography>
      )}
    </>
  );
};
